import React from "react";
import { getColor } from "../util/CC";
export default function Youtube(props) {

    const template = window.sitesettings.template_info;
    const { content = {} } = props;

    const {
        location = "main",
        component = "blank_space",
        container = true,
        data = {}
    } = content;

    const {
        url = "https://www.youtube.com/watch?v=dQw4w9WgXcQ",
        padding_x = 0,
        padding_y = 0,
        background_colour = 0,
        width = 600,
        aspect_ratio = "16/9",
        align = "center",
        full_width = false,
    } = data;

    function idFromURL(url) {

        const youtubeRegex = /^(?:https?:\/\/)?(?:www\.)?(?:youtube\.com\/(?:watch\?v=|embed\/)|youtu\.be\/)([\w-]{11})/;
        
        const vimeoRegex = /^(?:https?:\/\/)?(?:www\.)?vimeo\.com\/(\d+)/;
        
        const youtubeMatch = url.match(youtubeRegex);
        const vimeoMatch = url.match(vimeoRegex);

        // If there's a match, return the video ID, else return null
        if (youtubeMatch) {
            return { id: youtubeMatch[1], platform: 'youtube' };
        } else if (vimeoMatch) {
            return { id: vimeoMatch[1], platform: 'vimeo' };
        }
        
        return null;
    }



    const drawRender = () => {

        let _align;
        switch (align) {
            case "center":
                _align = "0 auto"
                break;
            case "right":
                _align = "0 0 0 auto"
                break
            default:
                _align = "0 0 0 0"
        }


        let _wrapperStyle = {
            width: (full_width) ? "100%" : width + "px",
            maxWidth: "100%",
            padding: padding_y + "px " + padding_x + "px",
            margin: _align,
        }

        let _iframeStyle = {
            width: "100%",
            display: "block",
            height: "100%",
            aspectRatio: aspect_ratio
        }

        const videoInfo = idFromURL(url);
        let embedUrl = "";
        
        if (videoInfo) {
            if (videoInfo.platform === 'youtube') {
                embedUrl = `https://www.youtube.com/embed/${videoInfo.id}`;
            } else if (videoInfo.platform === 'vimeo') {
                embedUrl = `https://player.vimeo.com/video/${videoInfo.id}`;
            }
        }

        return (
            <div className={(container) ? "preview-container" : ""}>
                <div style={{ "background": getColor(background_colour, template) }}>
                    <div style={_wrapperStyle}>
                        <iframe style={_iframeStyle} width="100%" height="100%" src={embedUrl} frameborder="0" allowfullscreen></iframe>
                    </div>
                </div>
            </div>
        )

    }


    return drawRender();
}